var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ContractorInvite", {
        attrs: {
          role: "CONTRACTOR",
          companyBusinessName: _vm.companyBusinessName,
          companyId: _vm.companyId,
          currentUserId: _vm.currentUserId,
          isManager: _vm.isManager,
        },
        model: {
          value: _vm.contractorDialog,
          callback: function ($$v) {
            _vm.contractorDialog = $$v
          },
          expression: "contractorDialog",
        },
      }),
      _c(
        "UiButton",
        {
          staticClass: "mr-12",
          attrs: {
            disabled: _vm.noCompany,
            id: "uploadContractor",
            size: _vm.size,
            variant: "blue",
          },
          on: { click: _vm.showInviteModal },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "flex flex-initial" }, [
            _vm._v(_vm._s(_vm.actionButtonContent)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }